<template>
  <div class="MerTokerUserDetail">
    <div class='top'>
      <img class='img-bg' src="../../resource/img/pic_blue_two.png"/>
      <div class="user-info">
        <img class="avatar" :src="avatar"/>
        <span class="name">{{ nickname }}</span>
        <span class='value'>{{ totalMoney }}</span>
        <span class='span'>红包金额</span>
        <div class='btn-div' @click="toCashdiv()">去提现</div>
      </div>
    </div>
    <div class='tab'>
      <div class='item' @click='tabTap(1)'>
        <span v-bind:class='"title"+tab == 1 ? "on" : ""'>订单</span>
        <div v-if="tab == 1" class='info'>
        </div>
      </div>
      <div class='item' @click='tabTap(2)'>
        <span v-bind:class='"title"+tab == 2 ? "on" : ""'>推广</span>
        <div v-if="tab == 2" class='info'>
        </div>
      </div>
      <!-- <div class='item' @click='tabTap(3)'>
         <span v-bind:class='"title"+tab == 3 ? "on" : ""'>关注</span>
         <div v-if="tab == 3" class='info'>

           <span>订单</span>
         </div>
       </div>-->
    </div>
    <div v-if="tab == 1">

      <div class='tab'>
        <div class='item' @click="orderTabTap(1)">
          <span v-bind:class='"title"+orderTab == 1 ? "on" : ""'>活动</span>
          <div v-if="orderTab == 1" class='info'>
          </div>
        </div>
        <div class='item' @click="orderTabTap(2)">
          <span v-bind:class='"title"+orderTab == 2 ? "on" : ""'>礼品</span>
          <div v-if="orderTab == 2" class='info'>
          </div>
        </div>
      </div>
      <div class='item-div' v-if="orderTab == 1" v-for="items in ListActOrder">
        <div class='title-div'>
          <span>{{ items.merName }}</span>
          <span class='right' v-if="items.paid==0">等待付款</span>
          <span class='right' v-if="items.paid==1">已完成</span>
        </div>
        <div class='title-div'>
          <span>订单号:{{ items.orderId }}</span>
          <!--  <span class='right' v-if="items.paid==1 && items.status==0">待消费</span>
            <span  class='right' style="color: black" v-if="items.paid==1 && items.status ==1">已消费</span>-->
        </div>
        <div class='content' style="height: 100%;">
          <img mode='aspectFill' class='pic' :src="imageUrl+items.actPic"></img>
          <div class='center'>
            <span class='title'>{{ items.actName }}</span>
            <!-- <font class='info'>规格：230ml</font> -->
          </div>
          <div class='right'>
            <div class>
              <span style='font-size:10px;'>￥ </span>
              <span>{{ items.price }}</span>
            </div>
            <span class='num'>x {{ items.buyNum }}</span>
          </div>
        </div>
        <div class='other-div'>
          <div class='count'>
            <span class='count-left'>{{ items.orderTime }}</span>
            <div class='count-right'>
              <span style='font-size:10px;'>￥</span>
              <span>{{ items.totalMoney }}</span>
            </div>
          </div>
          <div class='btns' v-if="items.paid== 0">
            <span class='order-btn' @click="btnremove(items, index)" style="margin-top: 0px;color: #6f6868">取消订单</span>
            <span class='order-btn' @click="btnpay(items, index)"
                  style='border:1px solid rgba(255,86,92,0.5);color:#FF565C;margin-top: 0px'>付款</span>
          </div>
          <div class='btns' v-else>
            <span class='order-btn' @click="consume(items,0)"
                  style='border:1px solid rgba(255,86,92,0.5);color:#FF565C;margin-top: 0px'>消费</span>
          </div>
        </div>
      </div>
      <div class='item-div' v-if="orderTab == 2" v-for="items in giftOrderList">
        <div class='title-div'>
          <span>订单号:{{ items.marketOrderId }}</span>
          <span class='right' v-if="items.status==0">待消费</span>
          <span class='right' style="color: black" v-else>已消费</span>
        </div>
        <div class='content' style="height: 100%;">
          <img mode='aspectFill' class='pic' :src="imageUrl+items.pic"></img>
          <div class='center'>
            <span class='title'>{{ items.name }}</span>
            <!-- <font class='info'>规格：230ml</font> -->
          </div>
          <div class='right'>
            <div class>
              <span style='font-size:10px;'>￥ </span>
              <span>{{ items.price }}</span>
            </div>
            <span class='num'>x {{ items.buyNum }}</span>
          </div>
        </div>
        <div class='other-div'>
          <div class='btns' v-if="items.status == 0" style="justify-content: space-between">
            <span class='count-left'>{{ items.addTime }}</span>
            <span class='order-btn' @click="consume(items,1)"
                  style='border:1px solid rgba(255,86,92,0.5);color:#FF565C;margin-top: 0px'>消费</span>
          </div>
        </div>
      </div>
      <div class='null' v-if="orderTab == 1 && ListActOrder.length == 0">
        <img class='pic' src="../../resource/img/pic_coupon_empty.png"></img>
        <div class='is-more'>暂无内容</div>
      </div>
      <div class='null' v-if="orderTab == 2 && giftOrderList.length == 0">
        <img class='pic' src="../../resource/img/pic_coupon_empty.png"></img>
        <div class='is-more'>暂无内容</div>
      </div>


    </div>


    <div v-if="tab == 2">

      <div class='tab'>
        <div class='item' @click="spreadTabTap(1)">
          <span v-bind:class='"title"+spreadTab == 1 ? "on" : ""'>直推</span>
          <div v-if="spreadTab == 1" class='info'>
          </div>
        </div>
        <div class='item' @click="spreadTabTap(2)">
          <span v-bind:class='"title"+spreadTab == 2 ? "on" : ""'>间推</span>
          <div v-if="spreadTab == 2" class='info'>
          </div>
        </div>
      </div>
      <div class="item" v-if="spreadTab == 1" v-for="items in firstSpreadList"
           style="margin-top:10px;background-color: white;width: 100vw;border-bottom:1px solid rgba(225, 225, 225, 1);">
        <div class='left'>
          <div class='num'><img class='pic' :src="items.avatar"></img></div>
          <div class='name'>{{ items.nickname }}</div>
        </div>
      </div>
      <div class="item" v-if="spreadTab == 2" v-for="items in secondSpreadList"
           style="margin-top:10px;background-color: white;width: 100vw;border-bottom:1px solid rgba(225, 225, 225, 1);">
        <div class='left'>
          <div class='num'><img class='pic' :src="items.avatar"></img></div>
          <div class='name'>{{ items.secondName }}</div>
          <span style="color: red;padding-right: 5px;">推荐</span>
          <div class='name'>{{ items.nickname }}</div>
        </div>
        <hr/>
      </div>
      <div class='null' v-if="spreadTab == 1 && firstSpreadList.length == 0">
        <img class='pic' src="../../resource/img/pic_coupon_empty.png"></img>
        <div class='is-more'>暂无内容</div>
      </div>
      <div class='null' v-if="spreadTab == 2 && secondSpreadList.length == 0">
        <img class='pic' src="../../resource/img/pic_coupon_empty.png"></img>
        <div class='is-more'>暂无内容</div>
      </div>
    </div>
  </div>
</template>

<script>
var activityId
var uid
export default {
  name: 'MerTokerUserDetail',
  data () {
    return {
      tab: 1,
      ListActOrder: [],
      openid: '',
      uid: null,
      activityId: null,
      avatar: '',
      nickname: '',
      totalMoney: 0,
      merId: null,
      spreadTab: 1,
      firstSpreadList: [],
      secondSpreadList: [],
      giftOrderList: [],
      fansid: null,
      imageUrl: sessionStorage.url,
      orderTab: 1,
    }
  },
  created () {
    let that = this
    that.$root.$children[0].pageData = 1
    that.merId = that.$route.query.merId
    that.activityId = that.$route.query.activityId
    that.uid = that.$route.query.uid
    that.avatar = that.$route.query.avatar
    that.nickname = that.$route.query.nickname
    if (that.$route.query.openid != null) {
      that.openid = that.$route.query.openid
    }
    that.fansid = that.$route.query.fansid
    if (that.$route.query.uid != null) {
      that.getOrderList()
      that.getTotolMoney()
      that.getGiftOrderList()
    }
    that.getspreadDetailList()

  },
  methods: {
    tabTap: function (value) {
      this.tab = value
    },
    spreadTabTap: function (value) {
      this.spreadTab = value
      this.getspreadDetailList(value)
    },
    orderTabTap: function (value) {
      this.orderTab = value
    },
    /*锐付款*/
    btnpay: function (items, index) {
      let that = this
      that.$router.push({
        path: '/MerTokerPay',
        // name: "MerTokerPay",
        query: {
          orderInfo: JSON.stringify(items),
          openid: that.openid
        }
      })
    },
    btnremove: function (items, index) {
      let that = this
      that.$axios
        .post(
          '/merchant/api/order/extend-order/delete',
          that.$qs.stringify({
            id: items.id
          })
        )
        .then(response => {
          alert(response.data.msg)
          that.ListActOrder = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    //获取订单列表
    getOrderList: function () {
      let that = this
      if (that.uid != null) {
        that.$axios
          .post(
            '/merchant/api/order/extend-order/list/user',
            that.$qs.stringify({activityId: that.activityId, uid: that.uid})
          )
          .then(response => {
            if (response.data.data.length > 0) {
              that.ListActOrder = response.data.data
            }
          })
          .catch(function (error) {
            //请求失败处理
            console.log(error)
          })
      }
    },

    getGiftOrderList: function () {
      let that = this
      if (that.uid != null) {
        that.$axios
          .post(
            '/merchant/api/activity/merchant-market-product-order/gift/list',
            that.$qs.stringify({
              activityId: that.activityId,
              uid: that.uid,
              activityType: 0,
              merId: that.merId,
              orderType: 1,
            })
          )
          .then(response => {
            if (response.data.data != null) {
              that.giftOrderList = response.data.data
            }
          })
          .catch(function (error) {
            //请求失败处理
            console.log(error)
          })
      }
    },

    //获取推广明细
    getspreadDetailList: function () {
      var that = this
      if (that.uid != null) {
        that.$axios
          .post(
            '/merchant/api/activity/merchant-fans-spread/list',
            that.$qs.stringify({
              activityId: that.activityId,
              uid: that.uid,
              storeId: that.storeId,
              merId: that.merId,
              spreadFansid: that.fansid,
              page: 1,
              limit: 60,
              tab: that.spreadTab
            })
          )
          .then(response => {
            if (response.data.code == 1) {
              if (response.data.data != null && response.data.data.list.length > 0) {
                if (that.spreadTab == 1) {
                  that.firstSpreadList = response.data.data.list
                } else if (that.spreadTab == 2) {
                  that.secondSpreadList = response.data.data.list
                }
              }
            }
          })
          .catch(function (error) {
            //请求失败处理
            console.log(error)
          })
      }
    },
    //跳转到提现界面
    toCashdiv: function () {
      if (this.uid != null) {
        this.$router.push({
          path: '/MerTokerCapitalDetail',
          query: {
            merId: this.merId,
            activityId: this.activityId,
            storeId: this.storeId,
            fansid: this.fansid,
            uid: this.uid
          }
        })
      }
    },
    //账户余额
    getTotolMoney: function () {
      var that = this
      //获取红包总金额
      that.$axios
        .post(
          '/merchant/api/activity/merchant-market-extend/extend-money',
          that.$qs.stringify({
            uid: that.uid,
            merId: that.merId
          })
        )
        .then(res => {
          that.totalMoney = res.data.data == null ? 0 : res.data.data
        })
        .catch(function (error) {
          //请求失败处理
          console.log(error)
        })
    },
    // 返回上一层
    goback: function () {
      this.$router.go(-1)
    },
    consume: function (items, orderType) {
      let that = this
      let orderId = ''
      if (orderType == 0) {
        orderId = items.orderId
      } else {
        orderId = items.marketOrderId
      }
      that.$router.push({
        path: '/MerTokerOrderUse',
        query: {
          orderId: orderId,
          activityId: items.activityId,
          orderType: orderType
        }
      })
    },
  }
}
</script>

<style scoped>

.MerTokerUserDetail {
  margin-top: 50px;
  background: #fff;
}

.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  height: 240px;
}

.top .img-bg {
  width: 100%;
  height: 218px;
  position: absolute;
  top: 0;
}

.top .user-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5%;
  z-index: 1;
  color: rgba(251, 70, 72, 1);
}

.top .user-info .avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #5a0707;
}

.top .user-info .name {
  margin-top: 10px;
  z-index: 1;
  color: #000;
}

.top .user-info .value {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 24px;
}

.top .user-info .span {
  font-size: 13px;
  font-family: PingFangSC-Regular;
  font-weight: 400;

}

.top .user-info .btn-div {
  border-radius: 20px;
  padding: 7px 25px;
  margin-top: 8px;
  border: 1px solid rgba(251, 70, 72, 1);
}

.tab {
  display: flex;
  align-items: center;
  box-shadow: 0px 1px 1px 0px rgba(238, 238, 238, 1);
  background: #fff;
}

.tab .item {
  flex: 1;
  position: relative;
  justify-content: center;
  display: flex;
  height: 50px;
  line-height: 50px;
  align-items: center;
}

.tab .item .name {
  span-align: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}

.tab .item .info {
  position: absolute;
  bottom: 0;
  width: 84px;
  height: 6px;
  background: linear-gradient(270deg, rgba(251, 70, 72, 1) 0%, rgba(255, 127, 118, 1) 100%);
  border-radius: 3px;
}

.tab .item .on {
  color: #ff565c;
}

.item-div {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  background-color: white;
}

.item-div .title-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 35px;
  line-height: 35px;
  background: #fff;
  padding: 0 24px;
}

.item-div .title-div .right {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #ff565c;
}

.item-div .content {
  display: flex;
  background: #fff;
  padding: 0 24px 10px 24px;
}

.item-div .content .pic {
  width: 90px;
  height: 90px;
  border-radius: 10px;
  margin-right: 16px;
  object-fit: cover;
}

.item-div .content .center {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.item-div .content .center .title {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.item-div .content .center .info {
  margin-top: 16px;
  height: 33px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 33px;
}

.item-div .content .right {
  display: flex;
  flex-direction: column;
}

.item-div .content .right .price {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.item-div .content .right .num {
  font-align: right;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.item-div .other-div {
  background: #fff;
  margin-top: 1px;
  padding: 0 24px;
}

.item-div .other-div .count {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  line-height: 30px;
}

.item-div .other-div .count .count-left {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}

.item-div .other-div .count .count-right {
  font-size: 20px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 86, 92, 1);
}

.item-div .other-div .btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 40px;
  line-height: 40px;
}

.item-div .other-div .btns .order-btn {
  height: 24px;
  line-height: 24px;
  margin-left: 15px;
  padding: 0 20px;
  font-align: center;
  border-radius: 25px;
  border: 1px solid rgba(74, 74, 74, 0.5);
  text-align: center;
  outline: none;
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  height: 50px;
  width: 100%;
  margin-bottom: 2px;
}

.item .left {
  display: flex;
  align-items: center;
}

.item .left .num {
  font-size: 28px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 86, 92, 1);
  min-width: 30px;
}

.item .left .pic {
  width: 32px;
  height: 32px;
  margin: 0 20px;
  border-radius: 50%;
}

.item .left .name {
  font-size: 15px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(50, 53, 60, 1);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 30vw;
}

.null {
  margin-top: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.null .pic {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerUserDetail.vue